(() => {
  if (!window.matchMedia) {
    return;
  }

  // const darkModeToggle = document.querySelector('dark-mode-toggle');
  const manifests = document.querySelectorAll('link[rel="manifest"]');
  const favicons = document.querySelectorAll(
    'link[rel="icon"],link[rel=apple-touch-icon]',
  );
  const maskIcons = document.querySelectorAll('link[rel="mask-icon') || [];

  const toggleTheme = (e) => {
    const darkModeOn = !!e.matches;

    manifests.forEach((link) => {
      link.href = darkModeOn ? link.dataset.hrefDark : link.dataset.hrefLight;
    });
    favicons.forEach((link) => {
      link.href = darkModeOn ? link.dataset.hrefDark : link.dataset.hrefLight;
    });
    maskIcons.forEach((link) => {
      link.color = darkModeOn ? '#ffffff' : '#000000';
    });
  };
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', toggleTheme);
  toggleTheme(window.matchMedia('(prefers-color-scheme: dark)'));
})();
